import { Callout } from '@/app/_components/Callout/index.jsx'
import { Gutter } from '@/app/_components/Gutter/index.jsx'

import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'

export const calloutBlockFragment = cmsGraphql(/* GraphQL */ `
  fragment calloutBlockFragment on CmsCalloutBlock {
    calloutReference {
      ... on CmsCallout {
        callout {
          iconName
          heading
          richText
          emphasis
          intent
          links {
            link {
              ...cmsLinkFragment
            }
          }
        }
      }
    }
  }
`)

export const calloutBlockTypename = 'CmsCallout'

export type CalloutBlockProps = {
  data: FragmentType<typeof calloutBlockFragment>
  isNested?: boolean
}

export const CalloutBlock = ({ data }: CalloutBlockProps) => {
  const { calloutReference } = getFragmentData(calloutBlockFragment, data)

  const callout = calloutReference?.callout

  if (!callout || (!callout.richText && !callout.heading)) {
    return null
  }

  return (
    <Gutter className="px-200 py-150 md:px-0 md:py-300">
      <Callout {...callout} />
    </Gutter>
  )
}
